import { useEffect, useState } from "react";
import { useSiteContent } from "@/context/SiteContentContext";

const isStandalone = () =>
    window.matchMedia?.("(display-mode: standalone)").matches || window.navigator.standalone === true;

const shouldShow = () => {
    if (new URLSearchParams(window.location.search).get("splash") === "1") return true;
    return isStandalone() && !sessionStorage.getItem("tc_splash_shown");
};

export default function SplashScreen() {
    const { content } = useSiteContent();
    const [phase, setPhase] = useState(() => (shouldShow() ? "in" : "done"));

    useEffect(() => {
        if (phase !== "in") return;
        sessionStorage.setItem("tc_splash_shown", "1");
        const t1 = setTimeout(() => setPhase("out"), 1600);
        const t2 = setTimeout(() => setPhase("done"), 2100);
        return () => { clearTimeout(t1); clearTimeout(t2); };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (phase === "done") return null;
    return (
        <div className={`splash-screen ${phase === "out" ? "is-out" : ""}`} data-testid="splash-screen">
            <div className="splash-logo">
                {content.logo_url ? (
                    <img src={content.logo_url} alt={content.brand_name} data-testid="splash-logo" />
                ) : (
                    <div className="font-display font-black text-3xl uppercase tracking-tight text-slate-900" data-testid="splash-brand">
                        {content.brand_name || "Turbo Cimi"}
                    </div>
                )}
            </div>
            <div className="splash-bar"><span /></div>
        </div>
    );
}
